import './styles/MyProfile.scss';
import HouseholdCard from "./profile/HouseholdCard";
import ParentCard from "./profile/ParentCard";
import Placeholder from 'components/Placeholder';
import React from 'react';
import Section from "./profile/Section";
import StudentCard from "./profile/StudentCard";
import duckify from "../../utils/duckify";
import {
  sharedPortalHouseholds,
  sharedPortalParents,
  sharedPortalStudents,
} from "../../ducks";

const MyProfile = ({households, parents, students}) => {
  return (
    <React.Fragment>
      <h1>My Profile</h1>
      <p>
        Welcome to Finalsite Enrollment Explore. You can manage or update
        your profile information here.
      </p>

      <Placeholder.loading ready={students.ready && parents.ready && households.ready}>
        <Section title="Students" itemName="student" addLink="/students">
          {students.map(student => (<StudentCard key={student.id} student={student}/>))}
        </Section>

        <Section title="Parents" itemName="parent" addLink="/parents">
          {parents.map(parent => (<ParentCard key={parent.id} parent={parent}/>))}
        </Section>

        <Section title="Households" itemName="household" addLink="/households">
          {households.map(household => (<HouseholdCard key={household.id} household={household}/>))}
        </Section>
      </Placeholder.loading>
    </React.Fragment>
  );
};

const mapDucksToProps = (_props) => ({
  households: sharedPortalHouseholds,
  students: sharedPortalStudents,
  parents: sharedPortalParents,
});

export default duckify(mapDucksToProps, undefined, undefined)(MyProfile);
